import nonEmptyStringValidator from 'foundation/js/inputValidators/nonEmptyStringValidator'

export default [
    {
        name: 'teamName',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'donationGoal',
        value: 0,
        isValid: false,
        validator: (value) => value > 0
    },
    {
        name: 'logo',
        value: null,
        isValid: false,
        validator: (value) => !value || value.length === 0 || value[0].size <= 10 * 1024 * 1024
    },
    {
        name: 'description',
        value: '',
        isValid: false,
        validator: (value) => value.length <= 250
    },
    {
        name: 'slogan',
        value: '',
        isValid: false,
        validator: (value) => value.length <= 100
    }
]
